import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Controller } from 'react-hook-form'
import { ControlledInputPropType } from "../input/ControlledInput";
import { StyledInput, StyledLabel } from "./fileUploadStyle";

export default function FileUpload({ imageUrl, setImageUrl, name, type = 'text', control, label, errors, size = 4, width, disabled = false, setValue, getValues }: ControlledInputPropType) {

    const convertFileToBase64 = (file: any) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
        });
    };


    const handleFileChange = async (event: any) => {
        if (event.target.files) {
            const files = event.target.files;
            if (files) {
                const selectedFile = files[0];
                if (selectedFile) {
                    setImageUrl(URL.createObjectURL(selectedFile))
                    const base64 = await convertFileToBase64(selectedFile);
                    setValue(name, base64);
                }
            }
        }
    };

    return (
        <>

            {imageUrl ? <div className="h-[100%] w-[100%]"  >
                <img
                    style={{ width: "240px", height: '150px', borderRadius: '6px' }}
                    src={imageUrl}
                    alt={'user'}

                />
                <DeleteForeverIcon sx={{ color: 'red' }} onClick={() => {
                    setImageUrl(null)
                    setValue(name, '')
                }} />
            </div> :
                <StyledLabel htmlFor="dropzone-file">
                    <div style={{ width: '72px', height: '72px' }}>
                        <ImageIcon />
                    </div>
                    <Controller
                        name={name}
                        control={control}
                        render={({ field }) => (
                            <StyledInput
                                {...field}
                                value={''}
                                id="dropzone-file"
                                type="file"
                                inputProps={{ accept: 'image/*' }}
                                onChange={(event: any) => {
                                    handleFileChange(event)
                                }}
                            />
                        )}
                    />
                </StyledLabel>

            }


        </>
    );
}

export const ImageIcon = () => {
    return <svg version="1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" enableBackground="new 0 0 48 48">
        <path fill="#8CBCD6" d="M40,41H8c-2.2,0-4-1.8-4-4V11c0-2.2,1.8-4,4-4h32c2.2,0,4,1.8,4,4v26C44,39.2,42.2,41,40,41z" />
        <circle fill="#B3DDF5" cx="35" cy="16" r="3" />
        <polygon fill="#9AC9E3" points="20,16 9,32 31,32" />
        <polygon fill="#B3DDF5" points="31,22 23,32 39,32" />
        <circle fill="#43A047" cx="38" cy="38" r="10" />
        <g fill="#fff">
            <rect x="36" y="32" width="4" height="12" />
            <rect x="32" y="36" width="12" height="4" />
        </g>
    </svg>
}